import { React, useState } from "react";
import { Stack, ToggleButton, ToggleButtonGroup } from "@mui/material";
import ViewAgendaRoundedIcon from "@mui/icons-material/ViewAgendaRounded";
import GridViewRoundedIcon from "@mui/icons-material/GridViewRounded";
import PropTypes from "prop-types";

function ToggleButtonComponent({ HandleAlignment }) {
  const [alignment, setAlignment] = useState("left");
  const handleAlignment = (event, newAlignment) => {
    if (newAlignment !== null) {
      setAlignment(newAlignment);
      HandleAlignment(newAlignment);
    }
  };
  return (
    <div className="b-toggle-container">
      <Stack className="b-toggle-container__stack" direction="row" spacing={4}>
        <ToggleButtonGroup
          value={alignment}
          exclusive
          onChange={handleAlignment}
          aria-label="text alignment"
        >
          <ToggleButton
            className="font-bold b-toggle-container__button"
            value="left"
            aria-label="left aligned"
          >
            <GridViewRoundedIcon />
            Tiles
          </ToggleButton>

          <ToggleButton
            className="font-bold b-toggle-container__button"
            value="right"
            aria-label="right aligned"
          >
            <ViewAgendaRoundedIcon />
            List
          </ToggleButton>
        </ToggleButtonGroup>
      </Stack>
    </div>
  );
}
ToggleButtonComponent.propTypes = {
  HandleAlignment: PropTypes.func.isRequired,
};
export default ToggleButtonComponent;
